import React from "react";
import t from "../../../helpers/t";

const UserInputItem = (props) => {
  if (props.value.name === "title") {
    return (
      <>
        <select
          id="user_item_input_title"
          type="text"
          className="form-control"
          name={props.name}
          required=""
          autoComplete="false"
          placeholder=""
          value={props.val == null ? "" : props.val}
          onChange={(e) => props.onChangeForm(e)}
        >
          <option value=""></option>
          <option value="mr">{t("user_title_mr")}</option>
          <option value="mrs">{t("user_title_mrs")}</option>
          <option value="mx">{t("user_title_mx")}</option>
          <option value="family">{t("user_title_family")}</option>
          <option value="company">{t("user_title_company")}</option>
        </select>
      </>
    );
  } else if (props.value.name === "username") {
    return (
      <>
        <input
          id={"user_item_input_" + props.value.name}
          type="text"
          className="form-control"
          name={props.name}
          style={
            typeof props.formError.username !== "undefined"
              ? {
                  backgroundColor: "#faede8",
                  borderColor: "#D25121",
                }
              : {}
          }
          required=""
          autoComplete="false"
          placeholder=""
          value={props.val}
          onChange={(e) => props.onChangeForm(e)}
        />
        <span className="help-text">
          {typeof props.val !== "undefined" && props.val === "" ? t("no_special_char_allowed") : ""}
        </span>
      </>
    );
  } else {
    return (
      <>
        <input
          id={"user_item_input_" + props.value.name}
          type="text"
          className="form-control"
          name={props.name}
          autoComplete="false"
          placeholder={props.placeholder ? t(props.placeholder) : ""}
          value={props.val}
          disabled={props.disabled}
          onChange={(e) => props.onChangeForm(e)}
        />

        <span className="help-text">
          {typeof props.formError[props.name] !== "undefined" ? t(props.formError[props.name]) : ""}
        </span>
      </>
    );
  }
};
export default UserInputItem;
